import appSettings from 'wanderu-config';
import {
    selectLocale,
    selectCurrency,
} from 'wanderu-i18n';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import { TixService } from 'wanderu-service-wapi';

import {
    actions as bookingActions,
    selectors as bookingSelectors,
} from '../../appstate';
import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-app-booking:fetchPaymentMethods');

function fetchPaymentMethods(opts) {
    return async (dispatch, getState) => {
        const working = selectors.selectWorking(getState());
        const success = selectors.selectSuccess(getState());
        if (working || success) {
            return;
        }

        dispatch(actions.startWork());

        let error;
        let actionMeta;
        try {
            const locale = selectLocale(getState());
            const currency = selectCurrency(getState());

            const body = {
                currency,
                locale,
                meta: {
                    form_version: '2.4.1',
                    mobile: appSettings.env.isClient
                        ? window.matchMedia('(max-width: 980px)').matches
                        : undefined,
                },
            };

            const { result } = await TixService.get('v3/book/paymentmethods');

            if (result?.paymentMethods) {
                dispatch(bookingActions.setPaymentMethods(result.paymentMethods));
            }
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetch', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });
            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(opts, actionMeta, error));
        }
    };
}

function reset(opts) {
    return actions.reset(opts);
}

const fetchPaymentMethodsAction = {
    fetch: fetchPaymentMethods,
    reset,
    ...selectors,
};

export {
    fetchPaymentMethodsAction,
};

export default {
    [namespace]: reducer,
};
